function validateForm(form, validationRules) {
  const emailPattern = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$");
  const numericPattern = new RegExp("[0-9]+");
  const alphabeticalPattern = new RegExp("[\\p{L} -]+");
  const errorMessages = fetchStandardErrorMessages();
  let firstInvalidField = null;

  for (let element in validationRules) {
    let selector = validationRules[element].selector;
    let wrapperSelector = validationRules[element].wrapperSelector;
    let field = form.querySelector(selector);
    let fieldWrapper = null;

    if (wrapperSelector) {
      fieldWrapper = field.closest(wrapperSelector);
    } else if (field.tagName.toLowerCase() === 'input' && !(field.type === 'checkbox' || field.type === 'radio')) {
      wrapperSelector = '.form-outline';
      fieldWrapper = field.closest(wrapperSelector);
    } else if (field.type === 'checkbox' || field.type === 'radio') {
      wrapperSelector = '.form-check';
      fieldWrapper = field.closest(wrapperSelector);
    } else if (field.tagName.toLowerCase() === 'select') {
      wrapperSelector = '.select-wrapper';
      fieldWrapper = field.closest(wrapperSelector);
    }

    // Set html attributes for visible elements and remove them for invisible elements

    if (field) {
      if (validationRules[element].required) {
        field.required = true;

        if (field.tagName.toLowerCase() === 'select') {
          if (fieldWrapper.querySelector('input').checkVisibility() === false)
          field.required = false;
        } else if (field.checkVisibility() === false) {
          field.required = false;
        }
      }

      if (validationRules[element].minLength) {
        field.minLength = validationRules[element].minLength;

        if (field.checkVisibility() === false) {
          field.removeAttribute('minLength');
        }
      }

      if (validationRules[element].maxLength) {
        field.maxLength = validationRules[element].maxLength;

        if (field.checkVisibility() === false) {
          field.removeAttribute('maxLength');
        }
      }

      if (validationRules[element].type === 'email') {
        field.pattern = emailPattern.source;
        field.patternType = 'email';

        if (field.checkVisibility() === false) {
          field.removeAttribute('pattern');
        }
      }

      if (validationRules[element].type === 'numeric') {
        field.pattern = numericPattern.source;
        field.patternType = 'numeric';

        if (field.checkVisibility() === false) {
          field.removeAttribute('pattern');
        }
      }

      if (validationRules[element].type === 'alphabetical') {
        field.pattern = alphabeticalPattern.source;
        field.patternType = 'alphabetical';

        if (field.checkVisibility() === false) {
          field.removeAttribute('pattern');
        }
      }

      if (validationRules[element].postalCodePattern) {
        field.pattern = validationRules[element].postalCodePattern;
        field.patternType = 'postalCode';

        if (field.checkVisibility() === false) {
          field.removeAttribute('pattern');
        }
      }

      if (validationRules[element].pattern) {
        field.pattern = validationRules[element].pattern;

        if (field.checkVisibility() === false) {
          field.removeAttribute('pattern');
        }
      }
    }

    if (field && field.checkVisibility() === false && fieldWrapper) {
      fieldWrapper.classList.remove('has-feedback');
    }

    // Check validity and determine error message

    if (!field.validity.valid) {
      if (firstInvalidField === null) {
        firstInvalidField = field;
      }

      determineErrorMessage(field, fieldWrapper, errorMessages);
    }

    // Add event handlers to display error messages dynamically

    if (field.type.toLowerCase() === 'checkbox') {
      field.addEventListener("input", (e) => {
        if (e.target.validity.valid) {
          setValidationMessage(e.target, e.target.closest(wrapperSelector), '');
        } else {
          determineErrorMessage(e.target, e.target.closest(wrapperSelector), errorMessages);
        }
      });
    } else if(field.type.toLowerCase() === 'radio') {
      fieldWrapper.querySelectorAll('input[type="radio"]').forEach((elem) => {
        elem.addEventListener("change", function (e) {
          if (e.target.validity.valid) {
            setValidationMessage(e.target, e.target.closest(wrapperSelector), '');
          } else {
            determineErrorMessage(e.target, e.target.closest(wrapperSelector), errorMessages);
          }
        });
      });
    } else if(field.tagName.toLowerCase() === 'select') {
      field.addEventListener("change", (e) => {
        if (e.target.validity.valid) {
          setValidationMessage(e.target, e.target.closest(wrapperSelector), '');
        } else {
          determineErrorMessage(e.target, e.target.closest(wrapperSelector), errorMessages);
        }
      });
    } else {
      field.addEventListener("focusout", (e) => {
          if (e.target.validity.valid) {
            setValidationMessage(e.target, fieldWrapper, '');
          } else {
            determineErrorMessage(e.target, fieldWrapper, errorMessages);
          }
        });
    }
  }

  // Check form validity

  if (form.checkValidity()) {
    removeInvalidFormNotice();

    return true;
  } else {
    form.classList.add('was-validated');

    displayInvalidFormNotice(form, errorMessages);

    if (firstInvalidField) {
      firstInvalidField.focus();
    }

    return false;
  }
}

function setValidationMessage(field, fieldWrapper, message) {
  let feedbackElement = fieldWrapper.querySelector('.invalid-feedback');

  if (feedbackElement === null) {
    feedbackElement = document.createElement('span');
    feedbackElement.classList.add('invalid-feedback');
  }

  if (field.tagName.toLowerCase() === 'input' && !(field.type === 'checkbox' || field.type === 'radio')) {
    fieldWrapper.querySelector('.form-label').after(feedbackElement);
  } else if (field.type === 'checkbox' || field.type === 'radio') {
    fieldWrapper.appendChild(feedbackElement);
  } else if (field.tagName.toLowerCase() === 'select') {
    fieldWrapper.querySelector('.form-label').after(feedbackElement);
  }

  if (message === '') {
    fieldWrapper.classList.remove('has-feedback');
  } else {
    fieldWrapper.classList.add('has-feedback');
  }

  feedbackElement.textContent = message;
}

function determineErrorMessage(field, fieldWrapper, errorMessages) {
  if (field.validity.valueMissing) {
    setValidationMessage(field, fieldWrapper, errorMessages.valueMissing);
  } else if (field.validity.tooShort) {
    setValidationMessage(field, fieldWrapper, errorMessages.tooShort);
  } else if (field.validity.tooLong) {
    setValidationMessage(field, fieldWrapper, errorMessages.tooLong);
  } else if (field.validity.patternMismatch && field.patternType === 'email') {
    setValidationMessage(field, fieldWrapper, errorMessages.invalidEmail);
  } else if (field.validity.patternMismatch && field.patternType === 'numeric') {
    setValidationMessage(field, fieldWrapper, errorMessages.numericOnly);
  } else if (field.validity.patternMismatch && field.patternType === 'alphabetical') {
    setValidationMessage(field, fieldWrapper, errorMessages.alphabeticalOnly);
  } else if (field.validity.patternMismatch && field.patternType === 'postalCode') {
    setValidationMessage(field, fieldWrapper, errorMessages.invalidPostalCode);
  } else if (field.validity.patternMismatch) {
    setValidationMessage(field, fieldWrapper, errorMessages.patternMismatch);
  } else if (field.validity.typeMismatch) {
    setValidationMessage(field, fieldWrapper, errorMessages.typeMismatch);
  } else {
    setValidationMessage(field, fieldWrapper, errorMessages.unknownError);
  }
}

function fetchStandardErrorMessages() {
  const messages = {};

  try {
    messages.valueMissing = document.querySelector('#formFeedbackValueMissing').textContent;
  } catch (error) {
    messages.valueMissing = 'This field is required.';
  }

  try {
    messages.tooShort = document.querySelector('#formFeedbackTooShort').textContent;
  } catch (error) {
    messages.tooShort = 'Value is too short.';
  }

  try {
    messages.tooLong = document.querySelector('#formFeedbackTooLong').textContent;
  } catch (error) {
    messages.tooLong = 'Value is too long.';
  }

  try {
    messages.patternMismatch = document.querySelector('#formFeedbackPatternMismatch').textContent;
  } catch (error) {
    messages.patternMismatch = 'Value does not meet the expected pattern.';
  }

  try {
    messages.invalidEmail = document.querySelector('#formFeedbackInvalidEmail').textContent;
  } catch (error) {
    messages.invalidEmail = 'Invalid email address.';
  }

  try {
    messages.numericOnly = document.querySelector('#formFeedbackNumericOnly').textContent;
  } catch (error) {
    messages.numericOnly = 'Value needs to contain only numbers.';
  }

  try {
    messages.alphabeticalOnly = document.querySelector('#formFeedbackAlphabeticalOnly').textContent;
  } catch (error) {
    messages.alphabeticalOnly = 'Value needs to contain only alphabetical characters.';
  }

  try {
    messages.invalidPostalCode = document.querySelector('#formFeedbackInvalidPostalCode').textContent;
  } catch (error) {
    messages.invalidPostalCode = 'Invalid postal code.';
  }

  try {
    messages.typeMismatch = document.querySelector('#formFeedbackTypeMismatch').textContent;
  } catch (error) {
    messages.typeMismatch = 'Incorrect value type.'
  }

  try {
    messages.unknownError = document.querySelector('#formFeedbackUnknownError').textContent;
  } catch (error) {
    messages.unknownError = 'Value is invalid.';
  }

  try {
    messages.invalidForm = document.querySelector('#formFeedbackInvalidForm').textContent;
  } catch (error) {
    messages.invalidForm = 'There are errors on the form. Please fix them before continuing.';
  }

  return messages;

}

function displayInvalidFormNotice(form, errorMessages) {
  let invalidFormNotice = document.querySelector('#invalid-form-notice');;

  if (!invalidFormNotice) {
    invalidFormNotice = document.createElement('div');
    invalidFormNotice.classList.add('woocommerce-error');
    invalidFormNotice.id = 'invalid-form-notice'
    invalidFormNotice.textContent = errorMessages.invalidForm

    form.parentElement.insertBefore(invalidFormNotice, form);
  }
}

function removeInvalidFormNotice() {
  let invalidFormNotice = document.querySelector('#invalid-form-notice');;

  if (invalidFormNotice) {
    invalidFormNotice.remove();
  }
}

export {
  validateForm
};
